import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import "swiper/swiper-bundle.css";

export default class HomepageMobileSlider {
    constructor() {
        const wrapper = document.querySelectorAll('.homepage-mobile-slides_swiper-wrapper');

        if(!wrapper.length) {
            return;
        }

        wrapper.forEach((wrap) => {
            const HomeMobileSlider = new Swiper('.homepage-mobile-slides__swiper', {
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },

                autoplay: {
                    delay: 5000,
                    pauseOnMouseEnter: true,
                },
            
                slidesPerView: 1,
                loop: true,
            
                modules: [ Pagination, Autoplay ],
            });
        });
    }
}